import React from "react";

interface GenerateIconProps extends React.SVGProps<SVGSVGElement> {}

const GenerateIcon: React.FC<GenerateIconProps> = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={15}
    height={17}
    fill="none"
    {...props}
  >
    <path
   
      strokeWidth={0.2}
      d="M8.58.104a.35.35 0 0 1 .35.35v1.142h3.965c.606 0 1.1.493 1.1 1.1V9.95h.307a.35.35 0 0 1 .35.35v1.22a.35.35 0 0 1-.35.35h-2.236l1.743 3.944a.35.35 0 0 1-.32.49h-1.502a.35.35 0 0 1-.32-.208l-1.865-4.227H4.948l-1.865 4.227a.35.35 0 0 1-.32.208H1.262a.35.35 0 0 1-.32-.49l1.742-3.945H.449a.35.35 0 0 1-.35-.35v-1.22a.35.35 0 0 1 .35-.349h.307V2.696c0-.607.494-1.1 1.1-1.1h3.966V.453a.35.35 0 0 1 .35-.35H8.58Zm3.635 15.5h.736l-1.642-3.721h-.736l1.642 3.72Zm-10.416 0h.736l1.642-3.721H3.44L1.8 15.603Zm-1-4.435h13.153v-.52H.8v.52Zm6.728-3.071 1.424 1.847h3.986L9.995 6.09 7.527 8.098ZM1.814 9.945h6.253L6.828 8.337a.349.349 0 0 1-.07-.063.35.35 0 0 1-.054-.097l-1.773-2.3-3.117 4.068Zm.041-7.65c-.22.001-.4.18-.4.401v6.568L4.653 5.09a.349.349 0 0 1 .277-.137l.08.009a.351.351 0 0 1 .198.127L7.1 7.544l2.733-2.225a.35.35 0 0 1 .262-.076l.068.016a.35.35 0 0 1 .169.119l2.963 3.882V2.696a.4.4 0 0 0-.4-.4H8.652a.352.352 0 0 1-.073.008H6.173a.356.356 0 0 1-.074-.008H1.855Zm5.52 1.474a.882.882 0 0 1 0 1.762.883.883 0 0 1 0-1.762Zm-.853-2.173H8.23V.803H6.522v.793Z"
    />
  </svg>
);

export default GenerateIcon;
